import { Fragment } from 'react';
import { Link } from 'react-router-dom';

/**
 * Breadcrumbs component
 * @param {Array} items - Array of breadcrumb items: { label, to, active }
 */
export default function Breadcrumbs({ items }) {
  return (
    <div style={{ display: 'flex', gap: '6px' }}>
      {items.map((item, idx) => (
        <Fragment key={idx}>
          {item.to ? (
            <Link to={item.to} className="text-12 text-dark">
              {item.label}
            </Link>
          ) : (
            <span className="text-12 text-primary font-bold">{item.label}</span>
          )}
          {idx < items.length - 1 && <span className="text-12">&gt;</span>}
        </Fragment>
      ))}
    </div>
  );
}
